import { Typography } from "@material-ui/core";

import './common-styles.scss';

const Title = ({ img, h1, h3 }) => {
  return (
    <div className='title-outer-div'>
      <div
        className='background'
        style={{ backgroundImage: `url(${img})` }}
      />

      <div className='title'>
        <Typography variant="h3">{h3}</Typography>
        <Typography variant="h1">{h1}</Typography>
      </div>

    </div>

  );
};

export default Title;
